import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@node_modules/@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CreateAlergiaComponent } from '@shared/components/default-alergias/create-alergia/create-alergia.component';
import { PacienteAlergiaDto, PacienteDto, PacienteServiceProxy } from '@shared/service-proxies/service-proxies';
import { CreatePacienteAlergiaComponent } from '@shared/components/default-paciente-alergias/create-paciente-alergia/create-paciente-alergia.component';
import { finalize } from '@node_modules/rxjs/operators';
import { Subscription } from '@node_modules/rxjs';
import { StringUtils } from '@shared/helpers/StringUtils';
import { FotoPerfilService } from '@shared/services/foto-perfil.service';

@Component({
  selector: 'card-informacoes-paciente',
  templateUrl: './card-informacoes-paciente.component.html',
  styleUrls: ['./card-informacoes-paciente.component.scss']
})
export class CardInformacoesPacienteComponent implements OnInit {

  protected alergias: string[] = [];
  protected urlFoto: string = "";
  private urlFotoSub: Subscription = new Subscription();
  @Input() paciente: PacienteDto;
  @Input() showLinks: boolean = true;
  @Input() showAddAlergia: boolean = false;
  totalAlergias: number;

  constructor(
    private router: Router,
    private _modalService: BsModalService,
    private _pacienteService: PacienteServiceProxy,
    private cdr: ChangeDetectorRef,
    private readonly _fotoService: FotoPerfilService,
  ) { }

  ngOnInit(): void {
    this.alergias = this.filtrasAlergias(this.paciente?.pacienteAlergias);
    if (this.showLinks) {
      const fotoUrl = this._fotoService.getUrlFoto();
      this.urlFoto = StringUtils.isNullOrEmpty(fotoUrl) ? 'assets/img/user.png' : fotoUrl;
      this.urlFotoSub = this._fotoService.getUrlFotoUpdateListener()
        .subscribe((url: string) => {
          this.urlFoto = StringUtils.isNullOrEmpty(url) ? 'assets/img/user.png' : url
          this.cdr.markForCheck();
        });
    }else{
       this.urlFoto = StringUtils.isNullOrEmpty(this.paciente.avatar) ? 'assets/img/user.png' : this.paciente.avatar
          this.cdr.markForCheck();
    }
  }

  protected navigateMeusDados() {
    this.router.navigate(['app', 'paciente', 'meu-perfil']);
  }

  protected navigateMinhasAlergias() {
    this.router.navigate(['app', 'paciente', 'minhas-alergias']);
  }

  protected novaAlergia(): void {
    const createModal = this._modalService.show(
      CreatePacienteAlergiaComponent,
      {
        class: 'modal-md',
        ignoreBackdropClick: true,
        initialState: {
          pacienteId: this.paciente.id
        }
      }
    );

    createModal.content.onSave.subscribe(() => {
      this.getNovasAlergias();
      abp.notify.success("Alergia cadastrada com sucesso!");
    });
  }

  private getNovasAlergias(): void {
    abp.ui.setBusy();
    this._pacienteService.getAlergiasPaciente(this.paciente.id).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((x) => {
      this.alergias = this.filtrasAlergias(x);
      this.cdr.detectChanges();
    })
  }

  private filtrasAlergias(pacienteAlergia: PacienteAlergiaDto[]): string[] {
    var alergias = pacienteAlergia?.map(x => x?.substancia)
      ?.filter(substancia => !!substancia);
    if (!alergias || alergias.length === 0) {
      return [];
    }
    this.totalAlergias = alergias.length - 3;
    return alergias.slice(0, 3);
  }
}
